(() => {
  const formatGermanEuro = value => value.replace(
    /(?:€[ \t\u00a0]*)(\d+(?:\.\d{3})*,\d{2})(?:[ \t\u00a0]*EUR)?|(?:EUR[ \t\u00a0]+)(\d+(?:\.\d{3})*,\d{2})/g,
    (_match, prefixed, coded) => `${prefixed || coded}\u00a0€`
  );
  const normalize = value => (value || '').replace(/\s+/g, ' ').trim();
  const swatchAltValue = input => typeof input?.value === 'string' ? normalize(input.value) : '';
  if (typeof module !== 'undefined' && module.exports) module.exports = { formatGermanEuro, normalize, swatchAltValue };
  if (typeof document === 'undefined') return;

  const product = document.querySelector('.filamelt-product');
  if (!product) return;

  const priceNote = 'Leider müssen wir auf Grund gestiegener Filament-Einkaufspreise je nach Farbvariante und Box-Größe unterschiedliche Aufpreise verlangen. Dies ist notwendig, da wir euch für jede Variante den besten Preis ermöglichen möchten.';
  const priceTextNodes = scope => {
    const nodes = [];
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, input, textarea, select, option, [contenteditable="true"]')) continue;
      nodes.push(node);
    }
    return nodes;
  };
  const updateSwatchAlt = () => {
    product.querySelectorAll('.gpo-app label[for] img.swatch-image').forEach(image => {
      const label = image.closest('label[for]');
      const input = label && document.getElementById(label.htmlFor);
      const option = swatchAltValue(input);
      if (option && !normalize(image.getAttribute('alt'))) image.alt = option;
    });
  };
  const update = () => {
    updateSwatchAlt();
    product.querySelectorAll('#paragraph-1.gpo-paragraph.gpo-tinymce').forEach(wrapper => {
      const paragraph = wrapper.querySelector('p');
      if (paragraph && normalize(paragraph.textContent) === priceNote) wrapper.hidden = true;
    });
    if (/^de(?:-|$)/i.test(document.documentElement.lang)) {
      product.querySelectorAll('[id^="price-"] .price__container, .gpo-element, .gpo-total, .lb-vd-container').forEach(scope => {
        priceTextNodes(scope).forEach(node => {
          const formatted = formatGermanEuro(node.nodeValue);
          if (formatted !== node.nodeValue) node.nodeValue = formatted;
        });
      });
    }
  };

  product.addEventListener('click', event => {
    const link = event.target.closest?.('.fm-product-facts__details');
    const target = link && document.getElementById(link.hash.slice(1));
    if (target?.matches('details.fm-product-details')) target.open = true;
  });

  const observerOptions = { childList: true, subtree: true, characterData: true };
  let updateFrame = null;
  let observer;
  const scheduleUpdate = () => {
    if (updateFrame !== null) return;
    updateFrame = requestAnimationFrame(() => {
      updateFrame = null;
      observer.disconnect();
      try {
        update();
      } finally {
        observer.observe(product, observerOptions);
      }
    });
  };
  observer = new MutationObserver(scheduleUpdate);

  product.addEventListener('toggle', scheduleUpdate, true);
  observer.observe(product, observerOptions);
  update();
})();
